import tinycolor from 'tinycolor2';

var Theme;
(function (Theme) {
  Theme.getLight = function (primaryColor) {
    return {
      inputBg: '$deepBlue1',
      inputBorder: '$grayBlue9',
      inputFocusBg: tinycolor('black').setAlpha(0.15).toHslString(),
      inputFocusBorder: primaryColor.helpers.pickScale(8),
      inputHoverBg: '$whiteA9',
      inputText: tinycolor('black').setAlpha(0.74).toHslString(),
      inputPlaceholder: '$blackA10',
      inputDisabledText: tinycolor('black').setAlpha(0.35).toHslString(),
      inputInvalidBorder: '$red9'
    };
  };
  Theme.getDark = function (primaryColor) {
    return {
      inputBg: '$grayBlue7',
      inputBorder: '$grayBlue9',
      inputFocusBg: tinycolor('black').setAlpha(0.15).toHslString(),
      inputFocusBorder: primaryColor.helpers.pickScale(11),
      inputHoverBg: '$whiteA4',
      inputText: tinycolor('white').setAlpha(0.8).toHslString(),
      inputPlaceholder: '$whiteA10',
      inputDisabledText: tinycolor('white').setAlpha(0.35).toHslString(),
      inputInvalidBorder: '$red9'
    };
  };
})(Theme || (Theme = {}));

export { Theme };
